<template>
  <v-card id="obligation">
    <v-card-title>
      <v-toolbar flat>
        <v-toolbar-title class="col-6">
          {{ resx.labels.obligations }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          :label="resx.labels.search"
          single-line
          hide-details
          v-model="search"
        >
        </v-text-field>
      </v-toolbar>
    </v-card-title>
    <v-card-text class="table-container fixed-header">
      <v-row row mr-4 class="count-items">
        <v-spacer></v-spacer>
        <v-col shrink>
          <span v-if="items.length > 0">
            {{
              `${resx.labels.countItems} 
            ${resx.labels.obligations.toLowerCase()}: ${count}`
            }}
          </span>
        </v-col>
      </v-row>
      <v-row class="table-container">
        <v-col>
          <v-data-table
            :class="{ 'layout-fixed': true }"
            :headers="headers"
            :items="items"
            :search="search"
            :no-data-text="resx.messages.noObligationsAvailable"
            :no-results-text="resx.messages.noObligationsFound"
            :loading=loading
            fixed-header
            height="auto"
            ref="dataTable"
            :items-per-page="itemsPerPage"
            :footer-props="{ itemsPerPageOptions: [15, 50, 100], itemsPerPageText: 'Mostrar' }"
            @update:items-per-page="saveItemsPerPage"
            sort-by="name"
            loading-text=""
          >
          <template v-slot:loading>
            <BarLoader :isLoading=loading />
          </template>

            <template v-slot:item.name="{ item }">
              <td>
                <a @click.prevent="edit(item)">{{ item.name }}</a>
              </td>
            </template>
            <template v-slot:item.comments="{ item }">
              <td>
                <comments-component
                  v-model="item.comments"
                  mode="link"
                  :label="resx.labels.comments"
                  :readonly="true"
                />
              </td>
            </template>
            <template v-slot:item.type="{ item }">
              <td class="hidden-sm-and-down">{{ resx.labels[item.type] }}</td>
            </template>
            <template v-slot:item.dueDateType="{ item }">
              <td class="hidden-sm-and-down">
                {{ resx.labels[item.dueDateType] }}
              </td>
            </template>
            <template v-slot:item.actions="{ item }">
              <td class="justify-center layout px-0">
                <v-menu bottom auto>
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on">
                      <v-icon>more_vert</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="edit(item)">
                      <v-list-item-action>
                        <v-icon color="primary">mode_edit</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>
                        {{ resx.labels.edit }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openTagPropagation(item)">
                      <v-list-item-action>
                        <v-icon color="primary">local_offer</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>
                        Propagar etiquetas
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="remove(item)">
                      <v-list-item-action>
                        <v-icon color="error">delete</v-icon>
                      </v-list-item-action>
                      <v-list-item-title>
                        {{ resx.labels.delete }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <div>
          <v-btn
            color="accent"
            class="addButton"
            fab
            bottom
            right
            absolute
            @click="create"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </div>
      </v-row>
      <v-row>
        <edit-obligation
          v-model="openDialog"
          v-on:close="onClose"
          v-on:save="onSave"
        ></edit-obligation>
        <tag-propagation
          :obligation="tagPropagationItem"
          :initial-summary="tagPropagationSummary"
          v-on:close="closeTagPropagation"
        ></tag-propagation>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
"use strict";

import { sprintf } from "sprintf-js";

import obligationService from "@/services/ObligationService";
import store from "@/store/store";

import commentsComponent from "../../common/comments.vue";
import editObligation from "@/components/views/obligations/edit-obligation.view.vue";
import BarLoader from "@/components/common/bar-loader.vue";
import tagPropagation from "@/components/views/obligations/tag-propagation.component.vue";

import moment from "moment";

export default {
  async mounted() {
    this.items = await obligationService.list();
    this.loading = false;
  },
  components: {
    editObligation,
    commentsComponent,
    BarLoader,
    tagPropagation
  },
  data() {
    const resx = this.$store.state.locale.resx;
    return {
      itemsPerPage: parseInt(localStorage.getItem(this.$options.name + '_itemsPerPage')) || 50,
      search: "",
      headers: [
        {
          text: resx.labels.name,
          value: "name"
        },
        {
          text: resx.labels.comments,
          value: "comments"
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.type,
          value: "type"
        },
        {
          class: "hidden-sm-and-down",
          text: resx.labels.dueDateType,
          value: "dueDateType"
        },
        {
          align: "center",
          sortable: false,
          text: resx.labels.actions,
          value: "actions"
        }
      ],
      items: [],
      openDialog: null,
      tagPropagationItem: null,
      tagPropagationSummary: null,
      loading: true
    };
  },
  methods: {
    saveItemsPerPage(val) {
      this.itemsPerPage = val;
      localStorage.setItem(this.$options.name + '_itemsPerPage', val);
    },
    create() {
      this.openDialog = {};
    },
    edit(obligation) {
      this.openDialog = {
        selectedItem: obligation
      };
    },
    async remove(obligation) {
      await this.botConfirmDialog({
        title: `${
          this.resx.labels.delete
        } ${this.resx.labels.user.toLowerCase()}`,
        content: sprintf(
          this.resx.messages.deleteObligationMessage,
          obligation.name
        )
      });
      let deleted = await obligationService.remove(obligation._id);
      const index = this.items.findIndex(
        o => o._id == obligation._id && deleted.isDeleted
      );
      this.items.splice(index, 1);
    },
    // Se carga el estado antes de abrir: el modal tiene que mostrar los botones
    // ya deshabilitados para las etiquetas que tienen todas las obligaciones.
    async openTagPropagation(obligation) {
      this.loading = true;
      try {
        this.tagPropagationSummary = await obligationService.getTagPropagation(obligation._id);
        this.tagPropagationItem = obligation;
      } finally {
        this.loading = false;
      }
    },
    closeTagPropagation() {
      this.tagPropagationItem = null;
      this.tagPropagationSummary = null;
    },
    onClose() {
      this.openDialog = null;
    },
    onSave(action) {
      if (action.isNew) {
        this.items.push(action.item);
      } else {
        this.$set(
          this.items,
          this.items.findIndex(i => i._id == action.item._id),
          action.item
        );
      }
      this.onClose();
    },
    parseDate(d) {
      return moment(d).format(store.state.constants.DATE_FORMAT);
    },
  },
  computed: {
    count: function() {
      let currentItems = this.$refs.dataTable.internalCurrentItems;
      let count = Object.keys(currentItems).length;
      return count;
    },
  },
  mixins: []
};
</script>
<style lang="scss">
#obligation {
  .v-card__text .table-container {
    padding-bottom: 50px;
  }
}

.addButton.v-btn--fab.v-size--default.v-btn--absolute.v-btn--bottom {
  position: fixed;
  bottom: 101px;
  right: 35px;
}
.v-card {
  overflow-y: auto;
  height: 100%;
}

</style>
